import React, { Component } from "react";
import { Navbar } from "react-bootstrap";
import AdminNavbarLinks from "./AdminNavbarLinks.jsx";
import Cookies from 'universal-cookie';
import cookieManagement from '../../utilities/Cookie';
const cookies = new Cookies();

let logoName = cookies.get('clientSubDomain') == undefined ? cookieManagement.setClientSubDomainToCookie() : cookies.get('clientSubDomain');
let logoVal = require('../../assets/img/clients/' + logoName + '/' + logoName + '.png');

class Header extends Component {
  constructor(props) {
    super(props);
    this.mobileSidebarToggle = this.mobileSidebarToggle.bind(this);
    this.state = {
      sidebarExists: false
    };
  }
  mobileSidebarToggle(e) {
    if (this.state.sidebarExists === false) {
      this.setState({
        sidebarExists: true
      });
    }
    e.preventDefault();
    document.documentElement.classList.toggle("nav-open");
    var node = document.createElement("div");
    node.id = "bodyClick";
    node.onclick = function () {
      this.parentElement.removeChild(this);
      document.documentElement.classList.toggle("nav-open");
    };
    document.body.appendChild(node);
  }
  render() {
    return (
      <Navbar fluid>
        <Navbar.Header>
          {
            (logoName == 'valvoline') ? <img style={{ width: '75px', marginTop: '10px' }} src={logoVal} alt="logo_image" />
            :(logoName == 'icapidilite') ? <img style={{ width: '150px', marginTop: '15px',height:'30px' }} src={logoVal} alt="logo_image" />
            : <img style={{ width: '100px', marginTop: '10px' }} src={logoVal} alt="logo_image" /> }
          <Navbar.Brand>

            {/* <a href="/#">{this.props.brandText}</a> */}
          </Navbar.Brand>
          <Navbar.Toggle onClick={this.mobileSidebarToggle} />
        </Navbar.Header>
        <Navbar.Collapse>
          <AdminNavbarLinks />
        </Navbar.Collapse>
      </Navbar>
    );
  }
}

export default Header;
